import { gql } from "gql";

export const GET_FILTER_META_INFO = gql(/* GraphQL */ `
  query GetFilterMetaInfo($filterableEntity: FilterableEntity!) {
    getFilterMetaInfo(filterableEntity: $filterableEntity) {
      ...DynamicAttributeFieldList
    }
  }
`);
